import {useTranslation} from 'react-i18next';
import StatusModal, {StatusModalStates} from 'components/StatusModal';

type Statuses = 'loading' | 'success' | 'error' | 'idle';
type Props = {
  open: boolean;
  state: Statuses;
};
function DeleteGuestStatusModal({open, state}: Props) {
  const {t} = useTranslation();
  const statusesMap: Record<Statuses, StatusModalStates> = {
    loading: StatusModalStates.LOADING,
    success: StatusModalStates.SUCCESS,
    error: StatusModalStates.ERROR,
    idle: StatusModalStates.IDLE,
  };

  const titleMap: Record<Statuses, string> = {
    loading: t('deleting_guest'),
    success: t('guest_deleted_successfully'),
    error: t('error_deleting_guest'),
    idle: t('deleting_guest'),
  };
  return <StatusModal open={open} state={statusesMap[state]} title={titleMap[state]} />;
}

export {DeleteGuestStatusModal};
